<template>
  <section>
    <!--工具条-->
    <el-row class="Nbut" style="margin: 23px auto 0px 0px">
      <el-input
        v-model="name"
        placeholder="请输入内容"
        id="inputhieght"
        style="width: 210px; margin: 0px 20px 10px 15px; height: 30px"
        clearable
      ></el-input>
      <el-button
        type="primary"
        @click="OcliSigin"
        style="
          line-height: 0;
          width: 70px;
          height: 30px;
          background: #007aff;
          border-radius: 3px;
          margin-right: 20px;
        "
        >查询</el-button
      >
      <el-button
        type="primary"
        @click="Add"
        style="
          line-height: 0;
          width: 70px;
          height: 30px;
          background: #007aff;
          border-radius: 3px;
          margin-right: 20px;
        "
        >新增</el-button
      >
      <el-button
        type="primary"
        @click="onClickfatherDatas"
        style="
          line-height: 0;
          width: 118px;
          height: 30px;
          background: #007aff;
          border-radius: 3px;
          margin-right: 50px;
          float: right;
          text-align: center;
        "
        >返回上一页</el-button
      >
    </el-row>

    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '90px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <!-- <el-table-column   type="selection" width="50" align="center"></el-table-column> -->
      <el-table-column
        type="index"
        width="60"
        align="center"
        label=" "
      ></el-table-column>
      <el-table-column
        prop="Id"
        label="ID"
        width="60"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="OrderSort"
        label="排序值"
        width="60"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Type"
        label="类型"
        width="200"
        :formatter="formattypename"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="CourseName"
        label="主标题"
        width="300"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Name"
        label="附标题"
        width="200"
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="ContentUrl"
        label="资源详情"
        width="200"
        sortable
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <el-button
            style="
              line-height: 0;
              width: 70px;
              height: 30px;
              border-radius: 3px;
              margin-right: 20px;
            "
            type="success"
            @click="LookViod(scope.row.ContentUrl, scope.row.Name)"
            >查看</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="ContentTime"
        label="时长"
        width="100"
        align="center"
        sortable
      ></el-table-column>
      <el-table-column
        prop="ClickRate"
        label="点击率"
        width="100"
        align="center"
        sortable
      ></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        width="200"
        align="center"
        :formatter="formatCreateTime"
        sortable
      ></el-table-column>
      <el-table-column prop="CreateTime" label="操作" align="center" sortable>
        <template slot-scope="scope">
          <!-- <span class="SpanList">查看二维码</span> -->
          <span class="SpanList" @click="Update(scope.row.Id)">编辑</span>
          <span class="SpanList" @click="Del(scope.row.Id)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-col :span="24" class="toolbar">
      <!-- <el-button
      style="margin-top: 20px;"
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      > -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="10"
        :total="total"
        style="text-align: center"
      ></el-pagination>
    </el-col>
    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFromShow"
      :close-on-click-modal="false"
      @opened="Addwangeditor()"
      width="50%"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          新增
          <span
            @click="DialogDown()"
            style="float: right; width: 100px; font-size: 20px; cursor: pointer"
            >x</span
          >
        </h2>
      </span>
      <el-form
        :model="addForm"
        label-width="100px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="课程附标题" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序值">
          <el-input-number
            v-model="addForm.OrderSort"
            auto-complete="off"
            :min="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="资源类型" prop="Type">
          <el-select
            v-model="addForm.Type"
            placeholder="请选择课程类型"
            @change="Addwangeditor"
          >
            <!-- <el-option label="--请选择--" :value="0"></el-option> -->
            <el-option label="音频" :value="1"></el-option>
            <el-option label="视频" :value="2"></el-option>
            <el-option label="图文" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频地址">
          <el-input v-model="addForm.ContentUrl" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="內容"
          v-if="addForm.Type != 3 && addForm.Type != null"
        >
          <el-upload
            :file-list="fileListArr"
            class="image-uploader"
            :auto-upload="true"
            ref="upload"
            :show-file-list="true"
            :drag="true"
            action
            :limit="1"
            :before-upload="beforeAvatarUploadVideo"
            :on-progress="handleChange"
            :on-remove="handleRemoveFj"
            :http-request="afterRead"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              一次只能上传一个文件，单文件不超过1G
            </div>
            <el-progress
              v-if="showprocess == true"
              type="line"
              :percentage="processlength"
              style="margin-top: 30px"
            ></el-progress>
          </el-upload>
          <!-- <el-upload
            class="avatar-uploader"
            action=""
            :headers="token"
            width="380"
            :on-success="handleAduioSuccess"
            :before-upload="beforeAudioUpload"
            v-bind:on-progress="handleChange"
            v-bind:show-file-list="false"
            :http-request="uploadFile"
          >
            <video
              v-if="addForm.ContentUrl != '' && !showprocess"
              v-bind:src="addForm.ContentUrl"
              class="avatar video-avatar"
            >
              您的浏览器不支持视频播放
            </video>
            <i
              v-else-if="showprocess"
              style="width: 320px; height: 180px"
              class="el-icon-plus"
              v-loading="true"
              element-loading-text="正在上传视频"
            ></i>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <el-progress
              :text-inside="true"
              v-show="showprocess"
              :percentage="processlength"
              :stroke-width="20"
              status="success"
            ></el-progress>
          </el-upload> -->
        </el-form-item>
        <el-form-item label="简介" prop="Briefing">
          <el-input type="textarea" v-model="addForm.Briefing"></el-input>
        </el-form-item>

        <el-form-item
          label="课程时长"
          prop="ContentTime"
          v-if="addForm.Type != 3 && addForm.Type != null"
        >
          <el-input
            v-model="addForm.ContentTime"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <!--使用编辑器
        -->
        <el-form-item label="详细" prop="Content" v-if="addForm.Type == 3">
          <div class="edit_container" id="Add_container"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFromShow = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="AddSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑 -->

    <el-dialog
      title=""
      :visible.sync="editFromShow"
      :close-on-click-modal="false"
      @opened="Editwangeditor()"
      width="50%"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          编辑
          <span
            @click="DialogDown()"
            style="float: right; width: 100px; font-size: 20px; cursor: pointer"
            >x</span
          >
        </h2>
      </span>
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="课程附标题" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序值">
          <el-input-number
            v-model="editForm.OrderSort"
            :min="1"
            auto-complete="off"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="资源类型" prop="Type">
          <el-select
            v-model="editForm.Type"
            placeholder="请选择课程类型"
            @change="Editwangeditor"
          >
            <el-option label="音频" :value="1"></el-option>
            <el-option label="视频" :value="2"></el-option>
            <el-option label="图文" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频地址">
          <el-input
            v-model="editForm.ContentUrl"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="內容"
          v-if="editForm.Type != 3 && editForm.Type != null"
        >
          <el-upload
            :file-list="fileListArr"
            class="image-uploader"
            :auto-upload="true"
            ref="upload"
            :show-file-list="true"
            :drag="true"
            action
            :limit="1"
            :before-upload="beforeAvatarUploadVideo"
            :on-progress="handleChange"
            :on-remove="handleRemoveFj"
            :http-request="afterRead"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              一次只能上传一个文件，单文件不超过1G
            </div>
            <el-progress
              v-if="showprocess == true"
              type="line"
              :percentage="processlength"
              style="margin-top: 30px"
            ></el-progress>
          </el-upload>
          <!-- action="/api/Img/UploadFilesPag" -->
          <!-- //api/Img/UploadFile/ -->
          <!-- <el-upload
            action=""
            class="avatar-uploader"
            :headers="token"
            width="380"
            :on-success="handleAduioSuccessEdit"
            :before-upload="beforeAudioUploadEdit"
            v-bind:on-progress="handleChange"
            v-bind:show-file-list="false"
            :http-request="uploadFileEdit"
          >
            <video
              v-if="editForm.ContentUrl != '' && !showprocess"
              v-bind:src="editForm.ContentUrl"
              class="avatar video-avatar"
            >
              您的浏览器不支持视频播放
            </video>
            <i
              v-else-if="showprocess"
              style="width: 320px; height: 180px"
              class="el-icon-plus"
              v-loading="true"
              element-loading-text="正在上传视频"
            ></i>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <el-progress
              :text-inside="true"
              v-show="showprocess"
              :percentage="processlength"
              :stroke-width="20"
              status="success"
            ></el-progress>
          </el-upload> -->
        </el-form-item>
        <el-form-item label="简介" prop="Briefing" v-if="editForm.Type == 3">
          <el-input type="textarea" v-model="editForm.Briefing"></el-input>
        </el-form-item>

        <el-form-item
          label="课程时长"
          prop="ContentTime"
          v-if="editForm.Type != 3 && editForm.Type != null"
        >
          <el-input
            v-model="editForm.ContentTime"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <!--使用编辑器
        -->
        <el-form-item label="详细" prop="Content" v-if="editForm.Type == 3">
          <div class="edit_container" id="edit_container"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFromShow = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <!-- 视频 -->
    <el-dialog
      :title="this.lTitle"
      :visible.sync="dialogvoid"
      width="40%"
      :close-on-click-modal="false"
    >
      <div class="video-wrap" style="width: 100%; float: left; oveflow: hidden">
        <video
          :src="this.VoidList"
          style="width: 100%; height: 500px"
          controls
        ></video>
        <!-- <iframe
          :src="this.VoidList"
          frameborder="0"
          allow="autoplay;encrypted-media"
          allowfullscreen
          style="width: 100%; height: 500px"
        >
        </iframe> -->
        <br />
        <br />
        资源地址:<el-input
          placeholder="请输入内容"
          v-model="VoidList"
          :disabled="true"
        >
        </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="dialogvoid = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  getcoursecatalogs,
  coursecatalogsdelete,
  coursecatalogsadd,
  coursecatalogsupdate,
  GetCatalogsBackOne,
  OtherUpload,
} from "../../api/api";
import { quillEditor } from "vue-quill-editor"; //调用富文本编辑器
import util from "../../../util/date"; //时间
import E from "wangeditor";
import OSS from "ali-oss";

export default {
  components: { quillEditor },
  data() {
    return {
      ConentType: null,
      numUpload: 1,
      processlength: 0,
      token: {
        Authorization: "Bearer ",
      },
      showprocess: false,
      ///是否选中
      isSelect: 0,
      //观看
      dialogvoid: false,
      VoidList: "",
      lTitle: "",
      ///修改
      editFromShow: false,
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入课程标题", trigger: "blur" }],
        Briefing: [{ required: true, message: "简介", trigger: "blur" }],
        Content: [{ required: true, message: "详情", trigger: "blur" }],
        ContentUrl: [{ required: true, message: "资源内容", trigger: "blur" }],
        Type: [{ required: true, message: "选择资源类型", trigger: "blur" }],
        ContentTime: [{ required: true, message: "时长", trigger: "blur" }],
      },
      editForm: {
        Name: "",
        Briefing: "",
        ContentUrl: "",
        Type: null,
        Content: "",
        ContentTime: 0,
        CourseId: 0,
        OrderSort: 1,
      },
      //新增
      addFromShow: false,
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入课程标题", trigger: "blur" }],
        Briefing: [{ required: true, message: "简介", trigger: "blur" }],
        Content: [{ required: true, message: "详情", trigger: "blur" }],
        ContentUrl: [{ required: true, message: "资源内容", trigger: "blur" }],
        Type: [{ required: true, message: "选择资源类型", trigger: "blur" }],
        ContentTime: [{ required: true, message: "时长", trigger: "blur" }],
      },
      addForm: {
        Name: "1212",
        Briefing: "",
        ContentUrl: "",
        Type: null,
        Content: "",
        ContentTime: 0,
        CourseId: 0,
        Content: "",
        OrderSort: 1,
      },
      ///查询
      name: "",
      ///表格数据
      users: [],
      sele: [],
      listLoading: false,
      ///按钮
      buttonList: [],
      activeName: "first",
      orgOptions: {},
      pieOrgOptions: {},
      piesOrgOptions: {},
      twoOrgOptions: {},
      threeOptions: {},

      optionsyear: [],
      optionsyear2: [],
      value1: "",
      value2: "",
      courseId: 0,
      classids: [],
      total: 0,
      editor: null,
      editor2: null,
      page: 1,
      fileListArr: [],
      dataObj: {
        region: "oss-cn-shanghai", //我的存储是北京，可根据具体配置自行修改
        accessKeyId: "LTAI5t8bGeYvpJGSf43kSVfk",
        accessKeySecret: "HzF8fto5Na8FQRta0PJFhFVmW0MgQc",
        bucket: "qinghesuyang",
      }, //存签名信息
      baseAli: "https://qinghesuyang.oss-cn-shanghai.aliyuncs.com", //我的存储是北京，可根据具体配置自行修改
    };
  },
  async created() {
    let token = localStorage.getItem("Token");
    this.token.Authorization += token;
    this.courseId = this.$route.query.Id;
    await this.getcoursecatalogs();
  },
  methods: {
    formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    handleRemoveFj(file, fileList) {
      this.fileListArr = fileList;
    },
    //分片上传
    afterRead(file) {
      this.progress = 0;
      var that = this;
      this.progressLoading = true;
      // 此时可以自行将文件上传至服务器
      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const filename = file.file.name.substring(0, tmpcnt);
      var value = new Date();
      var year = value.getFullYear();
      var month = this.formatNum(value.getMonth() + 1);
      var day = this.formatNum(value.getDate());

      var time = year + "/" + month + "/" + day + "/";
      let client = new OSS(this.dataObj);
      let userinfo = JSON.parse(
        window.localStorage.user ? window.localStorage.user : null
      );

      const progress = (p, _checkpoint) => {
        // Object的上传进度。
        //console.log(p, "p");
        this.progress = Math.round(p * 100, 3);
        // 分片上传的断点信息。
        //console.log(_checkpoint, "_checkpoint");
      };
      // 开始分片上传。
      async function multipartUpload() {
        try {
          console.log(file.file, "file.file");
          //const fileName ="/aaaaaa/" + that.userInfo.uID + "/" + time + file.file.name;
          const fileName =
            "/NewCloud/resource/" + userinfo.uID + "/" + time + file.file.name;

          console.log(fileName, "fileName");
          // 依次填写Object完整路径（例如exampledir/exampleobject.txt）和本地文件的完整路径（例如D:\\localpath\\examplefile.txt）。Object完整路径中不能包含Bucket名称。
          // 如果本地文件的完整路径中未指定本地路径（例如examplefile.txt），则默认从示例程序所属项目对应本地路径中上传文件。
          const result = await client.multipartUpload(fileName, file.file, {
            progress,
            // 指定meta参数，自定义Object的元信息。通过head接口可以获取到Object的meta数据。
            meta: {
              year: year,
              people: "people",
            },
          });
          console.log(result, "result");
          if (result.res.statusCode == "200") {
            that.loading = false;
            that.fileListArr.push({
              name: filename,
              url: that.baseAli + result.name,
              size: file.file.size,
            });
            // that.progressLoading = false;
            console.log(that.fileListArr, "  this.fileListArr");
          }
          // // 填写Object完整路径，例如exampledir/exampleobject.txt。Object完整路径中不能包含Bucket名称。
          // const head = await client.head(fileName);
          // console.log(head);
        } catch (e) {
          // 捕获超时异常。
          if (e.code === "ConnectionTimeoutError") {
            console.log("TimeoutError");
            // do ConnectionTimeoutError operation
          }
          console.log(e, "ccc");
        }
      }
      multipartUpload();
    },
    beforeAvatarUploadVideo(file) {
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      //1MB=1024*1024(1MB=1024KB 1KB=1024MB)
      const is10M = file.size / 1024 / 1024 < 1024;

      //限制文件上传大小
      if (!is10M) {
        this.$message.error("上传图片大小不能超过 1G!");
        return false;
      }

      return true;
    },
    emptyFn() {},
    // 返回组列表
    onClickfatherDatas() {
      this.$router.push("/Course/coursemanage");
      // this.$router.push({
      //   path: "/Course/courseData_index",
      //   query: { Id: id },
      // });
    },
    DialogDown() {
      this.addFromShow = false;
      this.editFromShow = false;
    },
    //按钮
    callFunction(item) {
      this.filters.name = item.search;
      this[item.Func].apply(this, item);
    },
    formattypename: function (row, column) {
      let typename = "其他";
      switch (row.Type) {
        case 1:
          typename = "音频";
          break;
        case 2:
          typename = "视频";
          break;
        case 3:
          typename = "图文";
          break;
      }
      return typename;
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.isSelect = val.Id;
        console.log(val);
      }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 点击事件
    onClick(params) {
      console.log("点击了柱状图", params.dataIndex);
      //this.$router.push("/Course/course_details");
      this.$router.push({
        path: "/Course/course_details",
        query: {
          classId: this.classids[params.dataIndex],
          courseId: this.courseId,
          studyYearId: this.value1,
          gradeId: this.value2,
        },
      });
    },
    selecttypelist() {
      this.page = 1;
      this.getcoursecatalogs();
    },
    //获取子目录列表
    async getcoursecatalogs() {
      console.log(this.page, "page");
      this.isSelect = 0;
      this.listLoading = true;
      this.fileListArr = [];
      await getcoursecatalogs({
        PageIndex: this.page,
        PageSize: 10,
        CourseId: this.courseId,
        Name: this.name,
      }).then((res) => {
        console.log(res);
        if (res.data.success) {
          this.users = res.data.response.data;
          this.total = res.data.response.dataCount;
          this.listLoading = false;
          console.log(this.users);
        } else {
          this.users = [];
          this.total = 0;
          this.listLoading = false;
        }
      });
    },
    //点击视频
    LookViod(url, name) {
      this.VoidList = url;
      this.lTitle = name;
      this.dialogvoid = true;
    },

    //修改
    Update(id) {
      // if (this.isSelect == 0) {
      //   this.$message({
      //     message: "请选择你修改的数据",
      //     type: "error",
      //   });
      //   return;
      // }
      setTimeout(() => {
        // this.$nextTick(() => {
        //   this.$refs["editForm"].clearValidate();
        // });
        GetCatalogsBackOne({ Id: id }).then((res) => {
          console.log(res);
          if (res.data.success) {
            this.fileListArr.push({
              name: res.data.response.Name,
              url: res.data.response.ContentUrl,
              size: 0,
            });
            // this.editForm = res.data.response;
            this.editForm.Name = res.data.response.Name;
            this.editForm.Briefing = res.data.response.Briefing;
            this.editForm.ContentUrl = res.data.response.ContentUrl;
            this.editForm.Type = res.data.response.Type;
            this.editForm.Content = res.data.response.Content;
            this.editForm.ContentTime = res.data.response.ContentTime;
            this.editForm.CourseId = res.data.response.CourseId;
            this.editForm.CourseTypeId = res.data.response.CourseTypeId;
            this.editForm.Id = res.data.response.Id;
            this.editForm.OrderSort = res.data.response.OrderSort;
            this.editFromShow = true;
          }
        });
      }, 1000);
    },
    editubmit() {
      let _this = this;
      if (this.addForm.Type == 3) {
        this.editForm.Content = this.editor.txt.html();
      }

      console.log(this.editForm);
      // this.editFormForm.CourseId = Number(this.courseId);
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            console.log(this.addForm);
            let para = Object.assign({}, this.editForm);
            para.ContentUrl =
              this.fileListArr.length == 0 ? "" : this.fileListArr[0].url;

            // para.CreateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            para.ModifyTime = para.CreateTime;
            var user = JSON.parse(window.localStorage.user);
            console.log(user);
            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            coursecatalogsupdate(para).then((res) => {
              console.log(res);
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                // this.$refs["editForm"].resetFields();
                this.editFromShow = false;
                this.getcoursecatalogs();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    ///添加内容
    Add() {
      this.addForm = {
        Name: "",
        Briefing: "",
        ContentUrl: "",
        Type: null,
        Content: "",
        ContentTime: 0,
        CourseId: 0,
        OrderSort: 1,
      };
      this.fileListArr = [];
      this.addFromShow = true;
      this.$nextTick(() => {
        this.$refs["addForm"].clearValidate();
      });
    },
    Addwangeditor() {
      console.log(this.addForm.Type);
      this.ConentType = this.addForm.Type;
      if (this.addForm.Type != 3) {
        return;
      }
      console.log(document.getElementById("Add_container"));
      setTimeout(() => {
        var c = document.getElementById("Add_container").innerHTML;
        if (c.length <= 0) {
          console.log("chua");
          this.editor = new E("#Add_container");
          //this.editor.customConfig.debug = true;
          this.editor.config.uploadImgServer = "/api/Img/UploadFiles";
          this.editor.create();

          console.log(this.editor.txt.html());
        }
        if (c != null) {
          this.editor.txt.html("");
        }
      }, 200);
    },
    Editwangeditor() {
      if (this.editForm.Type != 3) {
        return;
      }
      setTimeout(() => {
        var c = document.getElementById("edit_container").innerHTML;
        if (c.length <= 0 || b.length <= 0) {
          console.log("chua");
          this.editor = new E("#edit_container");
          this.editor.config.uploadImgServer = "/api/Img/UploadFiles";

          this.editor.txt.html(this.editForm.Content);
          this.editor.create();
          console.log(this.editor.txt.html());
        }
        if (c != null) {
          this.editor.txt.html(this.editForm.Conten);
        }
      }, 100);
    },
    AddSubmit() {
      let _this = this;
      if (this.addForm.Type == 3) {
        this.addForm.Content = this.editor.txt.html();
      }
      console.log(this.addForm);
      this.addForm.CourseId = Number(this.courseId);
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.ContentUrl =
              this.fileListArr.length == 0 ? "" : this.fileListArr[0].url;
            para.ModifyTime = para.CreateTime;
            var user = JSON.parse(window.localStorage.user);
            console.log(user);
            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }
            coursecatalogsadd(para).then((res) => {
              console.log(res);
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.addFromShow = false;
                this.getcoursecatalogs();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addFromShow = false;
              }
              this.addFromShow = false;
            });
          });
        }
      });
    },
    Del(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          coursecatalogsdelete({ catalogsId: id }).then((res) => {
            if (res.data.success) {
              this.getcoursecatalogs();
              this.$message({
                type: "success",
                message: res.data.msg,
              });
            } else {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    OcliSigin() {
      this.getcoursecatalogs();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getcoursecatalogs();
    },

    onEditorReady(editor) {},

    handleChange(file, fileList) {
      this.showprocess = true;
      if (file.percent < 99) this.processlength = file.percent;
      else this.processlength = 99;
      console.log(file);
      // const interval = setInterval(() => {
      //    if (this.processlength>=100) {
      //     clearInterval(interval);
      //     // this.processlength=0;
      //   //  this.showprocess = false;
      //      return;
      //   }
      //   this.processlength++;
      //  },80);
    },

    handleAduioSuccessEdit(res, file) {
      console.log(res, "handleAduioSuccessEdit");
      this.processlength = 100;
      if (res.success) {
        var refile = URL.createObjectURL(file.raw);
        // this.MuUrl =
        //   "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/aduio.png";
        this.editForm.ContentUrl = res.response;
        // this.addForm.ContentUrl = res.url;
        console.log(res.url);
        //  this.processlength = file.percent;
        this.$message({
          message: "上传成功",
          type: "success",
        });
        this.processlength = 0;
        this.showprocess = false;
      } else {
        this.$message({
          message: "上传失败，请重试",
          type: "error",
        });
      }
    },
    handleAduioSuccess(res, file) {
      console.log(file);
      this.processlength = 100;
      if (res.success) {
        var refile = URL.createObjectURL(file.raw);
        // this.MuUrl =
        //   "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/aduio.png";
        // this.editForm.ContentUrl = res.url;
        this.addForm.ContentUrl = res.url;
        console.log(res.url);
        //  this.processlength = file.percent;
        this.$message({
          message: "上传成功",
          type: "success",
        });
        this.processlength = 0;
        this.showprocess = false;
      } else {
        this.$message({
          message: "上传失败，请重试",
          type: "error",
        });
      }
    },
    beforeAudioUploadEdit(file) {
      console.log(this.editForm.Type);
      if (this.editForm.Type == 2) {
        console.log(file.type);
        const ismp3 = file.type === "video/mp4";
        const isLt2M = file.size / 1024 / 1024 < 1000;
        if (!ismp3) {
          this.$message.error("上传视频只能是 mp4格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传视频大小不能超过 1000MB!");
          return false;
        }
        if (ismp3 && isLt2M) {
          return true;
        } else {
          return false;
        }
      } else {
        console.log(file.type);
        const ismp3 = file.type === "audio/mpeg";
        const isLt2M = file.size / 1024 / 1024 < 1000;
        if (!ismp3) {
          this.$message.error("上传视频只能是 mp3格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传视频大小不能超过 1000MB!");
          return false;
        }
        if (ismp3 && isLt2M) {
          return true;
        } else {
          return false;
        }
      }
    },
    beforeAudioUpload(file) {
      console.log(this.editForm.Type);
      if (this.addForm.Type == 2) {
        console.log(file.type);
        const ismp3 = file.type === "video/mp4";
        const isLt2M = file.size / 1024 / 1024 < 1000;
        if (!ismp3) {
          this.$message.error("上传视频只能是 mp4格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传视频大小不能超过 1000MB!");
          return false;
        }
        if (ismp3 && isLt2M) {
          return true;
        } else {
          return false;
        }
      } else {
        console.log(file.type);
        const ismp3 = file.type === "audio/mpeg";
        const isLt2M = file.size / 1024 / 1024 < 1000;
        if (!ismp3) {
          this.$message.error("上传视频只能是 mp3格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传视频大小不能超过 1000MB!");
          return false;
        }
        if (ismp3 && isLt2M) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 上传文件
    uploadFileEdit(item) {
      let that = this;
      console.log(this.numUpload, "uploadFileEdit");
      var num = this.numUpload;
      console.log(item.file.name);
      console.log(num + "分页");
      const fileObj = item;
      // FormData 对象
      var file = item.file;
      const formData = new FormData();
      var time = new Date().getTime();
      //没文件为5m
      // 每片文件大小为5M
      var blockSize = 10 * 1024 * 1024;
      var blockNum = Math.ceil(file.size / blockSize);
      var nextSize = Math.min(num * blockSize, file.size);
      var fileData = file.slice((num - 1) * blockSize, nextSize);
      formData.append("file", fileData);
      // 文件名
      formData.append("name", file.name);
      // 总片数
      formData.append("chunks", blockNum);
      formData.append("chunk", num);
      formData.append("md5", time);
      formData.append("uid", "13570");
      OtherUpload(formData).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        if (!response.data.success && response.data.msg == "") {
          this.numUpload++;
          this.uploadFileEdit(fileObj);
        } else {
          console.log(this, that, "this,that,uploadFileEdit");
          this.numUpload = 1;
          console.log(response.data.response);
          this.editForm.ContentUrl = response.data.response;
          this.$set(this.editForm, "ContentUrl", response.data.response);
          console.log("filename", this.editForm.ContentUrl);
          this.$message.info("文件：" + item.file.name + "上传成功");
        }
      });
    },
    // 上传文件
    uploadFile(item) {
      let that = this;
      console.log(this.numUpload, "uploadFile");
      var num = this.numUpload;
      console.log(item.file.name);
      console.log(num + "分页");
      const fileObj = item;
      // FormData 对象
      var file = item.file;
      const formData = new FormData();
      var time = new Date().getTime();
      //没文件为5m
      // 每片文件大小为5M
      var blockSize = 10 * 1024 * 1024;
      var blockNum = Math.ceil(file.size / blockSize);
      var nextSize = Math.min(num * blockSize, file.size);
      var fileData = file.slice((num - 1) * blockSize, nextSize);
      formData.append("file", fileData);
      // 文件名
      formData.append("name", file.name);
      // 总片数
      formData.append("chunks", blockNum);
      formData.append("chunk", num);
      formData.append("md5", time);
      formData.append("uid", "13570");
      OtherUpload(formData).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        this.addForm.ContentUrl = ((num / blockNum) * 100).toFixed(3) + "%";
        if (!response.data.success && response.data.msg == "") {
          this.numUpload++;
          this.uploadFile(fileObj);
        } else {
          this.numUpload = 1;
          console.log(response.data.response);
          console.log(this, that, "this,that,uploadFile");
          this.addForm.ContentUrl = response.data.response;
          console.log("filename", this.addForm.ContentUrl);
          this.$message.info("文件：" + item.file.name + "上传成功");
        }
      });
    },
  },
  mounted() {
    ///获取按钮控件
  },
};
</script>

<style scoped>
.eltable {
  border: 1px solid #dbf4ff;
}
.class_header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sex_header {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.echarts_demo {
  width: 800px;
}
/* .Nbut {
  padding-bottom: 20px;
  border-bottom: 2px solid #606266;
} */
</style>